import { render, staticRenderFns } from "./TemplateDocumentCard.vue?vue&type=template&id=38ab473e&scoped=true"
import script from "./TemplateDocumentCard.vue?vue&type=script&lang=js"
export * from "./TemplateDocumentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ab473e",
  null
  
)

export default component.exports